import React from 'react';

import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_SITEMAP_LINKS } from '../../../mocks/queries';
import SubLink from './SubLink';
import MainLink from './MainLink';

const SitemapPage = () => {
  const { loading, data } = useSuspenseQuery(GET_SITEMAP_LINKS);

  // To be used later when listing reviews for one product
  if (loading) {
    return (
      <div>
        <ProgressLoader />
      </div>
    );
  }

  const {
    category_links: { mainCategories, subCategories },
    customer_service_links,
    other_links,
  } = data.sitemap_links;

  return (
    <div className="p-10 max-w-[1440px] mx-auto my-0">
      <div className="mt-0 mx-0 mb-10">
        <div className="text-[2rem] mb-[5px]">Shop By Category</div>
        <div className="block [column-count:3] [column-gap:20px] list-none m-0 max-[767px]:[column-count:2] max-[568px]:[column-count:1]">
          {mainCategories &&
            mainCategories.map(({ name, url, id }) => (
              <ul key={url} className="text-[#484848] list-none pt-0 px-0 pb-5">
                <li>
                  <MainLink {...{ name, url, id }} />
                  {subCategories[id] && (
                    <ul className="list-none pt-0 pr-0 pb-0 pl-[25px] mt-0 mx-0 mb-[15px]">
                      {subCategories[id].map(linkProps => (
                        <SubLink {...linkProps} key={linkProps.url} />
                      ))}
                    </ul>
                  )}
                </li>
              </ul>
            ))}
        </div>
      </div>
      <div className="mt-0 mx-0 mb-10">
        <div className="text-[2rem] mb-[5px]">Customer Service</div>
        <ul className="block [column-count:1] list-none m-0">
          {customer_service_links &&
            customer_service_links.map(linkProps => (
              <SubLink {...linkProps} key={linkProps.url} />
            ))}
        </ul>
      </div>
      <div className="mt-0 mx-0 mb-10">
        <div className="text-[2rem] mb-[5px]">Company & Other Information</div>
        <ul className="block [column-count:3] [column-gap:20px] list-none m-0 max-[767px]:[column-count:2] max-[568px]:[column-count:1]">
          {other_links &&
            other_links.map(linkProps => (
              <SubLink {...linkProps} key={linkProps.url} />
            ))}
        </ul>
      </div>
    </div>
  );
};

export default SitemapPage;
